<template>
    <div class="d-flex justify-center">
        <v-card
            :width="mobile ? '90%' : '65%'"
            max-height="78vh"
            color="white"
            elevation="3"
            class="d-flex flex-column"
        >
            <v-data-table-server
                :headers="product.headers"
                :items="product.lstProduct"
                :items-per-page="product.itemsPerPage"
                no-data-text="Nenhum produto encontrado"
                @click:row="openProduct"
                class="card-scroll"
                :page="product.page"
                :items-length="product.totalItems"
                @update:options="updateOptions"
            >
                <template v-slot:top>
                    <div :class="['px-5', mobile ? 'pb-3' : '']">
                        <v-row align="center" dense>
                            <v-col cols="12" md="9">
                                <v-text-field
                                    v-model="product.search"
                                    label="Pesquise aqui"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    max-width="300px"
                                    rounded
                                    class="pt-6"
                                    @keyup.enter="search()"
                                >
                                    <template v-slot:append-inner>
                                        <v-btn
                                            icon
                                            size="small"
                                            variant="text"
                                            @click="search()"
                                        >
                                            <v-icon class="pt-1">mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-end">
                                <v-btn
                                    color="primary"
                                    @click="openNewProduct()"
                                    rounded
                                    variant="elevated"
                                >
                                    Adicionar
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider></v-divider>
                </template>
                <template #headers="{ columns }">
                    <tr class="custom-header" >
                        <th v-for="column in columns" :key="column.key" style="text-align: center; font-weight: 600;">
                            {{ column.title }}
                        </th>
                    </tr>
                </template>
            </v-data-table-server>
        </v-card>
    </div>
    <Product/>
</template>

<script>
import { useDisplay } from 'vuetify'
import Product from '../Product.vue';

export default {
    setup () {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data: () => ({
    }),
    components: {
        Product
    },
    computed: {
        product: {
            get() {
                return this.$store.state.product
            },
        },
    },
    methods: {
        async openProduct(event, row) {
            this.$router.push({
                name: 'EditProduct',
                params: {
                    productId: row.item.productId
                }
            })
        },
        openNewProduct() {
            this.$router.push({ name: 'NewProduct' })
        },
        async search() {
            await this.$store.dispatch("product/search", { limit: this.product.itemsPerPage, reset: true })
        },
        async updateOptions(options) {
            this.$store.commit('product/setPage', options.page)

            await this.$store.dispatch("product/search", {
                limit: options.itemsPerPage,
                page: options.page,
                reset: true
            })
        }
    },
    async mounted() {
        await this.search()
        await this.$store.dispatch('pot/findAll')
        await this.$store.dispatch('category/findAll')
    },
    watch: {
        '$store.state.product.shouldReload': {
            async handler(val) {
                if (val) {
                    await this.search()
                    this.$store.commit('product/setShouldReload', false)
                }
            }
        }
    }
}
</script>

<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>